import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Component, ElementRef, Injector, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import { UsersService } from '../../../../services/entity/users.service';
import { ToastService } from '../../../../services/toast/toast.service';
import { EnterConfirmationCodeDialogContentComponent } from '../../enter-confirmation-code-dialog/enter-confirmation-code-dialog-content/enter-confirmation-code-dialog-content.component';

@Component({
  selector: 'edit-email-dialog-content',
  templateUrl: './edit-email-dialog-content.component.html',
  styleUrls: ['./edit-email-dialog-content.component.scss']
})
export class EditEmailDialogContentComponent extends AbstractDialogContent implements AfterViewInit {

  public className = 'EditEmailDialogContentComponent';

  public userId: string;
  isConfirmBtnDisabled: boolean = true;
  @ViewChild('newEmailInput') newEmailInput: ElementRef;



  constructor(
    public activeModal: NgbActiveModal,
    public dialog: NgbModal,
    public formService: FormService,
    private usersService: UsersService,
    private toastService: ToastService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  ngAfterViewInit() {
    this.newEmailInput.nativeElement.focus();
  }

  onConfimClick() {
    if (!this.isEmailValid)
      return;

    this.usersService.existEmail(this.newEmailInput.nativeElement.value).subscribe(response => {

      if (response == true) {
        this.toastService.error($localize`:@@EmailExist:E-Mail-Adresse existiert bereits.`, 4500, true);
        return;
      }

      this.activeModal.close({ status: "ok", email: this.newEmailInput.nativeElement.value });
    }, error => {
      this.toastService.error($localize`:@@UnexpectedErrorCheckUniqueEmail:Unerwarteter Fehler beim Überprüfen der E-Mail-Adresse.`, 5000, true);
      this.activeModal.close({ status: "error", email: "" });
    });

  }
  onCancelClick() {
    this.activeModal.close({ status: "canceled", email: "" });

  }

  onInputChange(event: any) {
    this.isConfirmBtnDisabled = !this.isEmailValid();
  }

  isEmailValid(): boolean {
    return (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(this.newEmailInput.nativeElement.value);
  }
}
